import mvtTextbox from '@/common/components/mvttextbox/mvt-textbox.vue';
import debounce from 'lodash/debounce';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import format from '@/common/utilities/format';
import { getCookie } from '../../utilities/nojq/_cookie.js';
import { geoServiceSearch, geoServiceLocation } from '../../utilities/nojq/_geoservice.js';
import { valideBed, getRecords, getUrlByRecord, disableSubscription } from '../../utilities/nojq/_notification.js';
import { redirect } from '../../utilities/nojq/_redirect.js';

// needed for when we run on node versions lower than 15 in some CI environments
import { AbortController } from 'node-abort-controller';

let fetchRequest;
let fetchAbort = new AbortController();
const abortFetch = () => {
    fetchAbort.abort();
    fetchAbort = new AbortController();
};

export default {
    name: 'mvtAutocomplete',
    components: {
        mvtTextbox,
    },
    inject: ['$eventBus'],
    emits: ['update:modelValue'],
    data() {
        return {
            delayLoad: 1,
            index: -1,
            categoryIndex: -1,
            searchText: '',
            suggestLinkList: [],
            defaultSuggestLinkList: [],
            isVisible: false,
            searchFilter: null,
            showGroupedList: false,
            hasMultiSearch: false,
        };
    },
    props: {
        options: {
            type: Object,
            default: () => ({
                includeAgentProfiles: true,
                hideDefaultSuggest: false,
                showGroupedSuggest: true,
                filterByState: false,
            }),
        },
        id: {
            type: String,
        },
        inputRefName: {
            type: String,
            default: 'input',
        },
        otherPages: {
            type: String,
            default: 'HT',
        },
        classname: {
            type: String,
        },
        btnclass: {
            type: String,
            default: 'regular btn',
        },
        placeholder: {
            type: String,
        },
        modelValue: {
            type: Object,
            default: () => {
                return {};
            },
        },
        dataType: {},
        hideRevertIcon: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
    },
    watch: {
        getSubscriptions: function () {
            this.defaultSuggestLinkList = this._mappingDefaultSuggestion();
        },
        modelValue: function () {
            // watch when the value gets changed
            this._setText(this._value.text);
        },
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getLastSearch', 'getPrevSearch', 'getAutoSuggest', 'getSubscriptions', 'getSplit']),
        searchSuggestions: function () {
            if (this.searchText.length > this.delayLoad) {
                return this.suggestLinkList;
            }
            return this.defaultSuggestLinkList;
        },
        refinedSuggestion: function () {
            return this.options.showGroupedSuggest;
        },
        otherSuggestion: function () {
            return Boolean(this.options.filterType);
        },
        getOtherPages: function () {
            return this.otherPages;
        },
        propertyTypeFilters: function () {
            if (this.glb.rentals) {
                return [
                    { name: 'House', filter: 'single-family' },
                    { name: 'Apartment', filter: 'condos' },
                    { name: 'Other', filter: 'other' },
                ];
            } else {
                return [
                    { name: 'House', filter: 'single-family' },
                    { name: 'Condo', filter: 'condos' },
                    { name: 'Multi', filter: 'multi-family' },
                ];
            }
        },
        groupedSuggestionLinks() {
            var result = [];
            var countTracker = {
                city: 0,
                zipcode: 0,
                county: 0,
                neighborhood: 0,
                school: 0,
                recentSearch: 0,
                savedSearch: 0,
                savedHomes: 0,
            };
            var cityList = [];
            var zipList = [];
            var currentList = [];
            var recentList = [];
            var savedSearchList = [];
            if (this.searchSuggestions.length) {
                this.searchSuggestions.map((v) => {
                    v.groupedText = typeof v.text === 'string' ? v.text.trim().replace(',', '') : v.text;
                    const type = v.value && v.value.type ? v.value.type : v.type;
                    let geoObj = v;
                    if (this.options.filterType && this.options.filterType !== 'Listings') {
                        let obj = this.getSuggestionForOthers({ geoObj: geoObj, type: type });
                        if (obj) {
                            result.push(obj);
                        }
                    } else {
                        switch (type) {
                            case 'city':
                                if (countTracker.city < 3) {
                                    cityList.push(v);
                                    countTracker.city++;
                                }
                                break;
                            case 'zipcode':
                                if (countTracker.zipcode < 3) {
                                    zipList.push(v);
                                    countTracker.zipcode++;
                                }
                                break;
                            case 'county':
                                if (countTracker.county < 1) {
                                    v.icon = 'icon-map';
                                    result.push({
                                        type: 'COUNTY',
                                        data: [v],
                                    });
                                    countTracker.county++;
                                }
                                break;
                            case 'neighborhood':
                                if (countTracker.neighborhood < 1) {
                                    v.icon = 'icon-property-lot';
                                    result.push({
                                        type: 'NEIGHBORHOOD',
                                        data: [v],
                                    });
                                    countTracker.neighborhood++;
                                }
                                break;
                            case 'school':
                                v.groupedText = v.text.replace(v.value.city, '').replace(v.value.state.toLowerCase(), '').replace(',', '').trim();
                                if (countTracker.school < 1) {
                                    result.push({
                                        type: 'SCHOOL',
                                        data: [v],
                                    });
                                    countTracker.school++;
                                }
                                break;
                            case 'address':
                                result.push({
                                    type: 'ADDRESS',
                                    data: [v],
                                });
                                break;
                            case 'current':
                                currentList.push({
                                    data: [v],
                                });
                                break;
                            case 'agent':
                                result.push({
                                    type: 'AGENT',
                                    data: [v],
                                });
                                break;
                            case 'recentSearch':
                                if (countTracker.recentSearch < 5) {
                                    v.icon = 'icon-search';
                                    v.action = 'redirect';
                                    v.iconAction = '';
                                    if (!v.url) {
                                        v.url = v.href && v.href.replace(this.glb.appUrl, '/');
                                    }
                                    if (isNaN(parseFloat(v.text))) {
                                        v.subText = v.text.split(' ').slice(-1)[0].toUpperCase();
                                        v.groupedText = v.text.replace(v.subText, '').trim();
                                    }
                                    recentList.push(v);
                                    countTracker.recentSearch++;
                                }
                                break;
                            case 'savedSearch':
                                if (countTracker.savedSearch < 3) {
                                    v.groupedText = v.item.input || v.text;
                                    v.subText = this.createSubtext(v.item);
                                    savedSearchList.push(v);
                                    countTracker.savedSearch++;
                                }
                                break;
                            case 'savedHomes':
                                if (countTracker.savedHomes < 1) {
                                    result.push({
                                        type: 'SAVED HOMES',
                                        data: [v],
                                    });
                                    countTracker.savedHomes++;
                                }
                                break;
                        }
                    }
                });
            }
            if (!this.glb.rentals) {
                let geoObj;
                if (countTracker.city) {
                    geoObj = cityList[0];
                    result.push({
                        type: 'AGENTS',
                        data: [
                            {
                                groupedText: 'top local Real Estate agents in ' + geoObj.value.city,
                                href: this.glb.appUrl + 'agents/' + geoObj.value.city.split(' ').join('-') + '-' + geoObj.value.state.toLocaleLowerCase() + '/',
                                icon: 'icon-user',
                            },
                        ],
                    });
                    result.push({
                        type: 'VETERANS',
                        data: [
                            {
                                groupedText: 'Veterans Agents & VA Loans',
                                href: this.glb.appUrl + 'veterans/',
                                icon: 'icon-shield-star',
                            },
                        ],
                    });
                    result.push({
                        type: 'LENDERS',
                        data: [
                            {
                                groupedText: 'mortgage lenders in ' + geoObj.value.city,
                                href: this.glb.appUrl + 'mortgages/',
                                icon: 'icon-hand-rate',
                            },
                        ],
                    });
                    result.push({
                        type: 'MARKET TRENDS',
                        data: [
                            {
                                groupedText: 'market trends in ' + geoObj.value.city,
                                href: this.glb.appUrl + geoObj.value.city.split(' ').join('-') + '-' + geoObj.value.state.toLocaleLowerCase() + '/market-trends/',
                                icon: 'icon-graph-increasing',
                            },
                        ],
                    });
                } else if (countTracker.neighborhood === 1 && !countTracker.city && !countTracker.zipcode) {
                    geoObj = result[0].data[0];
                    result.push({
                        type: 'AGENTS',
                        data: [
                            {
                                groupedText: 'top local Real Estate agents in ' + geoObj.value.neighborhood,
                                href: this.glb.appUrl + 'agents/' + geoObj.value.city.split(' ').join('-') + '-' + geoObj.value.state.toLocaleLowerCase() + '/',
                                icon: 'icon-user',
                            },
                        ],
                    });
                    result.push({
                        type: 'VETERANS',
                        data: [
                            {
                                groupedText: 'Veterans Agents & VA Loans',
                                href: this.glb.appUrl + 'veterans/',
                                icon: 'icon-shield-star',
                            },
                        ],
                    });
                    result.push({
                        type: 'LENDERS',
                        data: [
                            {
                                groupedText: 'mortgage lenders in ' + geoObj.value.neighborhood,
                                href: this.glb.appUrl + 'mortgages/',
                                icon: 'icon-hand-rate',
                            },
                        ],
                    });
                    result.push({
                        type: 'MARKET TRENDS',
                        data: [
                            {
                                groupedText: 'market trends in ' + geoObj.value.neighborhood,
                                href:
                                    this.glb.appUrl +
                                    geoObj.value.city.split(' ').join('-') +
                                    '-' +
                                    geoObj.value.state.toLocaleLowerCase() +
                                    '/' +
                                    geoObj.value.neighborhood.split(' ').join('-') +
                                    '/market-trends/',
                                icon: 'icon-graph-increasing',
                            },
                        ],
                    });
                } else if (countTracker.zipcode) {
                    geoObj = zipList[0];
                    result.push({
                        type: 'AGENTS',
                        data: [
                            {
                                groupedText: 'top local Real Estate agents in ' + geoObj.value.zipcode,
                                href: this.glb.appUrl + 'agents/' + geoObj.value.city.split(' ').join('-') + '-' + geoObj.value.state.toLocaleLowerCase() + '/',
                                icon: 'icon-user',
                            },
                        ],
                    });
                    result.push({
                        type: 'VETERANS',
                        data: [
                            {
                                groupedText: 'Veterans Agents & VA Loans',
                                href: this.glb.appUrl + 'veterans/',
                                icon: 'icon-shield-star',
                            },
                        ],
                    });
                    result.push({
                        type: 'LENDERS',
                        data: [
                            {
                                groupedText: 'mortgage lenders in ' + geoObj.value.zipcode,
                                href: this.glb.appUrl + 'mortgages/',
                                icon: 'icon-hand-rate',
                            },
                        ],
                    });
                    result.push({
                        type: 'MARKET TRENDS',
                        data: [
                            {
                                groupedText: 'market trends in ' + geoObj.value.zipcode,
                                href: this.glb.appUrl + geoObj.value.state.toLocaleLowerCase() + '/' + geoObj.value.zipcode + '/market-trends/',
                                icon: 'icon-graph-increasing',
                            },
                        ],
                    });
                } else if (countTracker.recentSearch) {
                    const item = { ...recentList[0] };
                    if (item.url && item.url.indexOf('/') === 0) {
                        item.url = item.url.substr(1);
                    }
                    if (!isNaN(parseFloat(item.text))) {
                        item.url = item.stateCode + '/' + item.zipcode + '/';
                    } else {
                        // this is to remove filters section from url when its not zipcode recent search
                        item.url = item.url.split('/')[0] + '/';
                    }
                    result.push({
                        type: 'AGENTS',
                        data: [
                            {
                                groupedText: 'top local Real Estate agents in ' + item.groupedText,
                                href: this.glb.appUrl + 'agents/' + item.url,
                                icon: 'icon-user',
                            },
                        ],
                    });
                    result.push({
                        type: 'VETERANS',
                        data: [
                            {
                                groupedText: 'Veterans Agents & VA Loans',
                                href: this.glb.appUrl + 'veterans/',
                                icon: 'icon-shield-star',
                            },
                        ],
                    });
                    result.push({
                        type: 'LENDERS',
                        data: [
                            {
                                groupedText: 'mortgage lenders in ' + item.groupedText,
                                href: this.glb.appUrl + 'mortgages/',
                                icon: 'icon-hand-rate',
                            },
                        ],
                    });
                    result.push({
                        type: 'MARKET TRENDS',
                        data: [
                            {
                                groupedText: 'market trends in ' + item.groupedText,
                                href: this.glb.appUrl + item.url + 'market-trends/',
                                icon: 'icon-graph-increasing',
                            },
                        ],
                    });
                }
            }
            result = [
                ...(cityList.length
                    ? [
                          {
                              type: 'CITIES',
                              data: cityList,
                          },
                      ]
                    : []),
                ...(zipList.length
                    ? [
                          {
                              type: 'ZIPCODE',
                              data: zipList,
                          },
                      ]
                    : []),
                ...(currentList.length ? currentList : []),
                ...(recentList.length
                    ? [
                          {
                              type: 'RECENT SEARCHES',
                              data: recentList,
                          },
                      ]
                    : []),
                ...(savedSearchList.length
                    ? [
                          {
                              type: 'SAVED SEARCH',
                              data: savedSearchList,
                          },
                      ]
                    : []),
                ...result,
            ];
            return result;
        },
        getUserId() {
            return this.glb.user.id;
        },
        _value: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
        getClasses() {
            var classnameArr = [];
            if (this.getOtherPages === 'ST') {
                classnameArr.push('autocomplete-list-other');
            } else {
                classnameArr.push('autocomplete-list');
            }
            if (this.classname) {
                classnameArr.push(this.classname);
            }
            return classnameArr;
        },
    },
    mounted() {
        var that = this;
        this.getPageSearchType();
        $(document).on('click.autocomplete' + this.vnumber, function () {
            $(document).trigger('dom.automplete.hide' + that.vnumber);
        });
        // $(document).on('scroll.autocomplete'+ this.vnumber, $.debounce(function(){
        //     $(document).trigger('dom.automplete.hide'+ that.vnumber);
        // }, 100));
        $(document).on('dom.automplete.hide' + this.vnumber, this.hide);
        $(this.$el).on('click.autocomplete', function (e) {
            e.stopPropagation();
        });
        if (this._value.text) {
            this._setText(this._value.text);
        }
        this.$eventBus.$on('eventbus-geosearch-apply', function (params) {
            that.geoSearch(params);
        });
        this.$eventBus.$on('eventbus-geosearch-autofocus', function () {
            $(that.$refs[that.inputRefName]).trigger('focus');
        });
        this.$eventBus.$on('eventbus-widgetbtnclick-search', function () {
            that._search();
        });
        this.updateSubscriptions(this.recordTolinks());
        if (this.glb.isPhone && this.glb.pageType !== 'vhome') {
            $(this.$refs[this.inputRefName]).on('keyup.autocomplete', function () {
                that.showGroupedList = !that.hideRevertIcon;
                $('#body').addClass('full-width-autocomplete-list');
            });
            $(this.$refs[this.inputRefName]).on('focus.autocomplete', function () {
                that.showGroupedList = !that.hideRevertIcon;
                $('#body').addClass('full-width-autocomplete-list');
            });
        }
        $(this.$refs[this.inputRefName]).one('focus', function () {
            $(document).one('autocomplete.init', function () {
                that._getSuggestion();
                $(that.$refs[that.inputRefName]).on('focus.autocomplete', function () {
                    that.updateSubscriptions(that.recordTolinks());
                    that.show();
                });
                $(that.$refs[that.inputRefName]).on(
                    'keyup.autocomplete',
                    debounce(function (e) {
                        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
                            return;
                        } else if (e.key === 'ArrowDown') {
                            return that.next();
                        } else if (e.key === 'ArrowUp') {
                            return that.prev();
                        } else if (e.key === 'Escape') {
                            return that.hide();
                        } else if (e.key === 'Enter') {
                            document.activeElement && document.activeElement.blur();
                            that._search();
                            return that.hide();
                        }
                    }, 300)
                );
                $(that.$refs[that.inputRefName]).on(
                    'input.autocomplete',
                    debounce(function () {
                        that.searchText = that._getText();
                        that.show();
                        that._getSuggestion();
                    }, 300)
                );
                $(that.$refs[that.inputRefName]).trigger('focus.autocomplete');
            });
            if (this.getUserId) {
                let option = {
                    page: 1,
                    size: 3,
                    userId: this.getUserId,
                    savedSearchesSort: 'LAST_VIEW_TIME',
                    userFavoriteSort: '',
                    trigger: this.$options.name,
                };
                this.getAutoSuggestSavedSearch(option).then(function () {
                    $(document).trigger('autocomplete.init');
                });
            } else {
                $(document).trigger('autocomplete.init');
            }
        });
    },
    methods: {
        ...mapActions('glb', ['getAutoSuggestSavedSearch']),
        ...mapMutations('glb', ['updateSubscriptions']),
        saveSerarch() {
            this.$eventBus.$emit('eventbus-save-search', { trigger: this.$options.name });
        },
        getPageSearchType() {
            let pageType = '';
            if (this.glb && this.glb.pageType) {
                pageType = this.glb.pageType;
            }
            if (this.glb && this.glb.pageData && this.glb.pageData.pageType) {
                pageType = this.glb.pageData.pageType;
            }
            if (['vschools_base', 'vschools_state', 'vmarket-trends-home', 'vmarket-trends-state', 'vsitemap_agentstates', 'vsitemap_stateagent', 'vsitemap_states'].indexOf(pageType) > -1) {
                this.hasMultiSearch = true;
            }
        },
        getSuggestionForOthers(params) {
            var geoObj = params.geoObj;
            var type = params.type;
            var obj = null;
            if (this.options.filterType === 'Market Trends') {
                switch (type) {
                    case 'city':
                        obj = {
                            type: '',
                            data: [
                                {
                                    groupedText: 'Trends in ' + geoObj.value.city + ', ' + geoObj.value.state,
                                    href: this.glb.appUrl + geoObj.value.city.split(' ').join('-') + '-' + geoObj.value.state.toLocaleLowerCase() + '/market-trends/',
                                    icon: '',
                                },
                            ],
                        };
                        break;
                    case 'zipcode':
                        obj = {
                            type: '',
                            data: [
                                {
                                    groupedText: 'Trends in ' + geoObj.value.zipcode + ', ' + geoObj.value.state,
                                    href: this.glb.appUrl + geoObj.value.state.toLocaleLowerCase() + '/' + geoObj.value.zipcode + '/market-trends/',
                                    icon: '',
                                },
                            ],
                        };
                        break;
                }
            } else if (this.options.filterType === 'Agents') {
                switch (type) {
                    case 'city':
                        obj = {
                            type: '',
                            data: [
                                {
                                    groupedText: 'top local Real Estate agents in ' + geoObj.value.city + ', ' + geoObj.value.state,
                                    href: this.glb.appUrl + 'agents/' + geoObj.value.city.split(' ').join('-') + '-' + geoObj.value.state.toLocaleLowerCase() + '/',
                                    icon: 'icon-user',
                                },
                            ],
                        };
                        break;
                    case 'zipcode':
                        obj = {
                            type: '',
                            data: [
                                {
                                    groupedText: 'top local Real Estate agents in ' + geoObj.value.zipcode + ', ' + geoObj.value.state,
                                    href: this.glb.appUrl + 'agents/' + geoObj.value.city.split(' ').join('-') + '-' + geoObj.value.state.toLocaleLowerCase() + '/',
                                    icon: 'icon-user',
                                },
                            ],
                        };
                        break;
                }
            } else if (this.options.filterType === 'Schools') {
                switch (type) {
                    case 'city':
                        obj = {
                            type: '',
                            data: [
                                {
                                    groupedText: 'Schools in ' + geoObj.value.city + ', ' + geoObj.value.state,
                                    href: this.glb.appUrl + 'schools/' + geoObj.value.city.split(' ').join('-') + '-' + geoObj.value.state.toLocaleLowerCase() + '/',
                                    icon: '',
                                },
                            ],
                        };
                        break;
                }
            }
            return obj;
        },
        revertGroupList() {
            this.searchText = '';
            this.showGroupedList = false;
            $('#header').removeClass('full-width-autocomplete-list');
            this.hide();
        },
        getFilterValue(val) {
            if (val.filter === this.searchFilter) {
                this.searchFilter = null;
            } else {
                this.searchFilter = val.filter;
            }
        },
        iconAction(item) {
            switch (item.iconAction) {
                case 'removeNotification':
                    item.value && this.removeSubscription(item.value);
                    break;
            }
        },
        action(item) {
            var that = this;
            $('#header').removeClass('full-width-autocomplete-list');
            this.searchFilter = null;
            switch (item.action) {
                case 'geoSearch':
                    this.geoSearch();
                    break;
                case 'redirect':
                    this.redirectTo(item.url);
                    break;
                case 'searchBySuggestion':
                    this.searchBySuggestion(item);
                    break;
                default:
                    if (item.href) {
                        redirect(item.href);
                    }
                    break;
            }
            this.hide();
            setTimeout(() => {
                that.searchText = '';
                that.index = -1;
            }, 10);
        },
        createSubtext(item) {
            var bedText = '';
            var PriceText = '';
            var iconText = '';
            var subText = '';
            if (item.minBed && valideBed(item.propertyType)) {
                bedText = item.minBed + '+ Beds';
            }
            if (item.maxPrice) {
                if (!isNaN(item.maxPrice)) {
                    PriceText = '<$' + format.friendlyPrice(item.maxPrice);
                } else {
                    const price = Number(item.maxPrice.replace(/[^0-9\.]+/g, ''));
                    if (!isNaN(price)) {
                        PriceText = '<$' + format.friendlyPrice(price);
                    } else {
                        PriceText = '';
                    }
                }
            }
            subText = bedText + ' ' + PriceText;
            if (item.propertyType.indexOf('SINGLE_FAMILY_HOUSE') >= 0) {
                iconText += '<i class="icon-property-single-family"></i>';
            }
            if (item.propertyType.indexOf('CONDO') >= 0) {
                iconText += '<i class="icon-property-condo"></i>';
            }
            if (item.propertyType.indexOf('MULTI_FAMILY') >= 0) {
                iconText += '<i class="icon-property-multi-family"></i>';
            }
            if (item.propertyType.indexOf('LAND') >= 0) {
                iconText += '<i class="icon-property-lot"></i>';
            }
            if (item.propertyType.indexOf('MOBILE') >= 0) {
                iconText += '<i class="icon-property-mobile"></i>';
            }
            if (item.propertyType.indexOf('OTHER') >= 0) {
                iconText += '<i class="icon-property-other"></i>';
            }
            subText = iconText + ' ' + subText;
            return subText;
        },
        recordTolinks() {
            var that = this;
            var data = getRecords();
            data.sort(function (a, b) {
                return a.zipcode - b.zipcode;
            });
            return data.reduce(function (list, record) {
                if (record.disabled) {
                    return list;
                }
                var text = '';
                text = record.zipcode;
                var subText = that.createSubtext(record);
                list.push({
                    icon: 'icon-times',
                    iconAction: 'removeNotification',
                    value: record.zipcode,
                    text: text,
                    subText: subText,
                    zipcode: record.zipcode,
                    stateCode: record.stateCode,
                    href: getUrlByRecord(record),
                    type: 'recentSearch',
                });
                return list;
            }, []);
        },
        removeSubscription(zipcode) {
            var that = this;
            disableSubscription({
                    zipcodes: [zipcode],
                })
                .then(function () {
                    that.updateSubscriptions(that.recordTolinks());
                    that.$eventBus.$emit('eventbus-disableSubscription', zipcode);
                });
        },
        geoSearch: function () {
            var gpsPath = `/for-sale/`;
            if (this.glb.rentals) {
                gpsPath = '/rentals/';
            }
            geoServiceLocation().then((latlng) => {
                if (latlng) {
                    const url = `${gpsPath}@${latlng.lat},${latlng.lng}/`;
                    this.redirectTo(url);
                    this.$eventBus.$emit('eventbus-showmap', true);
                } else {
                    console.log('Cannot get current localtion info');
                    if (location.pathname.indexOf(gpsPath) !== 0) {
                        this.redirectTo(gpsPath);
                    }
                    return;
                }
            });
        },
        redirectTo(path) {
            if (this.glb.pageType === 'vmapsearch') {
                this.$eventBus.$emit('eventbus-redirect-keepfilter', path);
            } else {
                redirect(location.origin + path);
            }
        },
        searchBySuggestion(item) {
            if (item) {
                const addComma = !item.text.includes(',') ? ', ' : '';
                if (item.value.address_components && item.value.address_components.length > 1) {
                    this._value = {
                        text: item.text + (item.subText ? addComma + item.subText : ''),
                        geo: item.value,
                        isGoogleGeo: true,
                    };
                } else {
                    this._value = {
                        text: item.text + (item.subText ? addComma + item.subText : ''),
                        geo: item.value,
                        isGoogleGeo: false,
                        extraPath: item.extraPath && `${item.extraPath}/`,
                    };
                }
            }
        },
        _getText: function () {
            return $(this.$refs[this.inputRefName]).val();
        },
        _setText: function (text) {
            text && $(this.$refs[this.inputRefName]).val(text);
        },
        _mappingDefaultSuggestion() {
            if (this.options.hideDefaultSuggest) {
                return [];
            }
            let autoSuggest = [
                {
                    icon: 'icon-location-arrow',
                    action: 'geoSearch',
                    text: 'Current Location',
                    url: '/for-sale/',
                    type: 'current',
                },
            ];

            let getSearch = this.getPrevSearch || this.getLastSearch;
            if (getSearch && getSearch.displayText) {
                autoSuggest.push({
                    text: getSearch.displayText,
                    icon: 'icon-search',
                    action: 'redirect',
                    url: getSearch.url.replace(/p-\d*\//, ''),
                    type: 'recentSearch',
                });
            }
            if (this.glb.savedSearches && this.glb.savedSearches.length) {
                var length = Math.min(3, this.glb.savedSearches.length);
                for (var i = 0; i < length; i++) {
                    var item = this.glb.savedSearches[i];
                    autoSuggest.push({
                        item: item,
                        text: item.searchName,
                        subText: '(Saved ' + format.dateGetString(item.createdDate) + ')',
                        icon: 'icon-bookmark-o',
                        action: 'redirect',
                        url: '/' + item.url,
                        type: 'savedSearch',
                    });
                }
            }
            if (this.glb.favoriteListings && this.glb.favoriteListings.length) {
                autoSuggest.push({
                    text: 'My Favorite Homes (' + this.glb.favoriteListings.length + ')',
                    href: this.glb.appUrl + 'my-movoto/my-home-search/favorites/',
                    icon: 'icon-heart',
                    type: 'savedHomes',
                });
            }
            autoSuggest = autoSuggest.concat(this.getSubscriptions);
            return autoSuggest;
        },
        _mappingGeoSuggestion(data) {
            var that = this;
            if (data && data.length) {
                return data.map(function (item) {
                    if (item.agentType) {
                        return {
                            text: item.displayName || (item.firstName || '') + ' ' + (item.lastName || ''),
                            href: that.glb.appUrl + 'agents/' + item.profileUrl,
                            icon: 'icon-user',
                            type: 'agent',
                        };
                    }
                    var geoInfo = {
                        lat: item.location && item.location.lat,
                        lng: item.location && item.location.lon,
                        type: item.geotype,
                    };
                    var text = null;
                    var subText = null;
                    var icon = null;
                    switch (item.geotype) {
                        case 'city':
                            geoInfo.state = item.state;
                            geoInfo.city = item.city && item.city.toLocaleLowerCase();
                            text = geoInfo.city + ', ';
                            subText = geoInfo.state;
                            icon = 'icon-pin';
                            break;
                        case 'county':
                            geoInfo.state = item.state;
                            geoInfo.city = item.county && item.county.toLocaleLowerCase();
                            text = geoInfo.city + ', ';
                            subText = geoInfo.state;
                            icon = 'icon-pin';
                            break;
                        case 'mcd':
                            geoInfo.state = item.state;
                            geoInfo.city = item.mcd && item.mcd.toLocaleLowerCase();
                            text = geoInfo.city + ', ';
                            subText = geoInfo.state;
                            icon = 'icon-pin';
                            break;
                        case 'state':
                            geoInfo.state = item.state;
                            text = geoInfo.state;
                            subText = geoInfo.state && geoInfo.state;
                            icon = 'icon-pin';
                            break;
                        case 'zipcode':
                            geoInfo.state = item.state;
                            geoInfo.city = item.city && item.city.toLocaleLowerCase();
                            geoInfo.zipcode = item.zipcode;
                            text = geoInfo.zipcode + ', ';
                            subText = geoInfo.state;
                            icon = 'icon-pin';
                            break;
                        case 'neighborhood':
                            geoInfo.state = item.state;
                            geoInfo.city = item.city && item.city.toLocaleLowerCase();
                            geoInfo.neighborhood = item.neighborhood && item.neighborhood.toLocaleLowerCase();
                            geoInfo.generatePath = true;
                            text = geoInfo.neighborhood + ', ';
                            subText = geoInfo.city + ', ' + geoInfo.state;
                            icon = 'icon-pin';
                            break;
                        case 'community':
                            geoInfo.state = item.state;
                            geoInfo.city = item.city && item.city.toLocaleLowerCase();
                            geoInfo.community = item.community && item.community.toLocaleLowerCase();
                            text = geoInfo.community + ', ';
                            subText = geoInfo.city + ', ' + geoInfo.state;
                            icon = 'icon-pin';
                            break;
                        case 'school':
                            geoInfo.state = item.state;
                            geoInfo.city = item.city && item.city.toLocaleLowerCase();
                            //todo remove item.name.input once api upgrade
                            geoInfo.schoolName = (item.schoolname || (item.name && item.name.input) || item.full_name || '').toLocaleLowerCase();
                            geoInfo.schoolBoundaryId = item.schoolboundaryid;
                            geoInfo.schoolId = item.schoolid;
                            text = geoInfo.schoolName + ', ';
                            subText = geoInfo.city + ', ' + geoInfo.state;
                            icon = 'icon-cap';
                            break;
                        case 'address':
                            text = item.searchText;
                            subText = '';
                            icon = 'icon-pin';
                            geoInfo.address_components = item.address_components;
                            break;
                    }
                    return {
                        action: 'searchBySuggestion',
                        icon: icon,
                        text: text.replace(', USA', ''),
                        subText: subText,
                        value: geoInfo,
                    };
                });
            }
            return [];
        },
        __getGeoSuggestionData() {
            return geoServiceSearch(this.searchText).then(function (result) {
                var suggestionList = [];
                if (result && result.length) {
                    result.forEach((obj) => {
                        if (obj.address_components.length === 1) {
                            return;
                        }
                        var geoData = {
                            searchText: obj.formatted_address,
                            address_components: obj.address_components,
                            geotype: 'address',
                            location: {
                                lat: obj.geometry.location.lat(),
                                lon: obj.geometry.location.lng(),
                            },
                        };
                        suggestionList.push(geoData);
                    });
                }
                return suggestionList;
            });
        },
        _getSuggestion() {
            var that = this;
            var displayText = this.searchText;
            if (this.searchText && displayText && displayText.length > this.delayLoad) {
                if (fetchRequest && fetchRequest.state === 'pending') {
                    abortFetch();
                }
                const urlParams = new URLSearchParams({
                    key: displayText,
                    filter_by_state: this.options.filterByState,
                    includeAgentProfiles: this.options.includeAgentProfiles,
                    state: (this.glb.geo && this.glb.geo.state) || getCookie('lastSearchState'),
                });
                fetchRequest = fetch(`${this.glb.appUrl}api/geo/autosearch_v2/?${urlParams}`, { signal: fetchAbort.signal })
                    .then((response) => response.json())
                    .then((data) => {
                        fetchRequest.state = 'complete';
                        var dict = data;
                        that.suggestLinkList = [];
                        if (typeof data === 'string') {
                            dict = JSON.parse(data);
                        }
                        if (dict && dict.length) {
                            that.suggestLinkList = that._mappingGeoSuggestion(dict);
                        } else {
                            that.__getGeoSuggestionData().then((dict) => {
                                if (dict && dict.length) {
                                    that.suggestLinkList = that._mappingGeoSuggestion(dict);
                                } else {
                                    that.suggestLinkList = [];
                                }
                            });
                        }
                    })
                    .catch((err) => {
                        // log error to console only if request was not aborted on purpose, 20 is the code for AbortError https://developer.mozilla.org/en-US/docs/Web/API/DOMException
                        if (err.code !== 20) {
                            console.error(err);
                        }
                    });
                fetchRequest.state = 'pending';
            } else {
                if (fetchRequest && fetchRequest.state === 'pending') {
                    abortFetch();
                }
                that.defaultSuggestLinkList = that._mappingDefaultSuggestion();
            }
            this.index = -1;
        },
        _search: function () {
            var that = this;
            var text = this._getText();
            var isMlsNumberFlag = (/^([a-zA-Z\d]+)?[\d]{4,}$/.test(text) && text.length > 5 && text.indexOf(' ') < 0) || /^\d{2}-\d{3,}$/.test(text);

            if (!isMlsNumberFlag && this.searchSuggestions && this.searchSuggestions.length && this.searchText.length > this.delayLoad) {
                var suggest;
                if (this.index != -1) {
                    suggest = this.searchSuggestions[this.index];
                } else {
                    suggest = this.searchSuggestions[0];
                }
                this.action(suggest);
            } else if (text) {
                if (/Current Location/i.test(text)) {
                    return;
                }
                if (isMlsNumberFlag) {
                    that._value = {
                        text: text,
                        isMlsNumber: true,
                        geo: {},
                    };
                } else {
                    geoServiceSearch(text).then(function (results) {
                        if (results && results.length) {
                            var geoObj;
                            if (results[0].geometry && results[0].geometry.location) {
                                geoObj = {
                                    address_components: results[0].address_components,
                                    lat: results[0].geometry.location.lat(),
                                    lng: results[0].geometry.location.lng(),
                                };
                            } else {
                                geoObj = results[0];
                            }
                            that._value = {
                                text: text,
                                isGoogleGeo: true,
                                //geo: results[0]
                                geo: geoObj,
                            };
                        } else {
                            that._value = {
                                text: text,
                                isGoogleGeo: true,
                                geo: null,
                            };
                        }
                    });
                    that.hide();
                }
            }
        },
        update(text) {
            this._setText(text);
        },
        onClick() {
            if (this.options && this.options.isHomeFinderWidget) {
                this.$eventBus.$emit('eventbus-homefinder-search', this._value);
            } else {
                this._search();
            }
        },
        hide() {
            if (this.hasMultiSearch) {
                this.hideMulti();
            } else {
                if (this.isVisible) {
                    this.isVisible = false;
                    this.showGroupedList = false;
                    $('#body').removeClass('autocomplete-show');
                }
            }
        },
        show() {
            if (this.hasMultiSearch) {
                this.showMulti();
            } else {
                if (!this.isVisible) {
                    this.isVisible = true;
                    $('#body').addClass('autocomplete-show');
                }
            }
        },
        hideMulti() {
            $('#body').removeClass('autocomplete-show');
            $('#body').removeClass('autocomplete-show-other');
        },
        showMulti() {
            if (this.getOtherPages === 'ST') {
                $('#body').addClass('autocomplete-show-other');
                $('#body').removeClass('autocomplete-show');
            } else {
                $('#body').addClass('autocomplete-show');
                $('#body').removeClass('autocomplete-show-other');
            }
        },
        next() {
            if (this.index >= this.searchSuggestions.length) {
                this.index = 0;
            } else {
                this.index += 1;
            }
        },
        prev() {
            if (this.index <= 0) {
                this.index = this.searchSuggestions.length - 1;
            } else {
                this.index -= 1;
            }
        },
    },
    beforeUnmount() {
        $(document).off('click.autocomplete' + this.vnumber);
        $(document).off('dom.automplete.hide' + this.vnumber);
        this.$eventBus.$off('eventbus-geosearch-autofocus');
        this.$eventBus.$off('eventbus-widgetbtnclick-search');
    },
};
